import React from 'react';
import ImageWrapper from '../ImageWrapper/ImageWrapper';
import Button from '../Button/Button';
import './ComparePreview.css';

function ComparePreview({
    products,
    maxItems,
    compareBackgroundColor,
    compareBorderColor,
    compareLabelColor,
    compareNotificationNumber,
    compareNotificationBackgroundColor,
    compareNotificationLabelColor,
    onRemove,
    onCompare
}) {
    const handleRemove = (productId) => {
        if (onRemove) onRemove(productId);
    };

    const handleCompare = () => {
        if (onCompare) onCompare();
    };

    const renderProducts = () => {
        let list = [];
        for (let i = 0; i < maxItems; i++) {
            const product = products[i];
            list.push(
                <div key={`compare-preview-product-${i}`} className='compare-preview-product'>
                    {!!product && (
                        <React.Fragment>
                            <div className='compare-preview-product-remove-button' onClick={() => handleRemove(product.id)}>
                                <span className='compare-preview-product-remove-button-icon'>x</span>
                            </div>
                            <div className='compare-preview-product-image-container'>
                                <ImageWrapper image={product.getMainImage('m')} alt='Card' display='block' width={100} height='auto' loadDelay={0}/>
                            </div>
                        </React.Fragment>
                    )}
                </div>
            );
        }
        return list;
    };

    return (
        <div className='compare-preview'>
            <div className='compare-preview-first-row'>
                <div className='compare-preview-products'>{renderProducts()}</div>
                <div className='compare-preview-buttons'>
                    <div className='compare-preview-button'>
                        <Button
                            icon={undefined}
                            label='Comparar productos'
                            labelColor={compareLabelColor}
                            backgroundColor={compareBackgroundColor}
                            borderColor={compareBorderColor}
                            borderRadius={12}
                            disabled={products.length <= 1}
                            notificationNumber={compareNotificationNumber}
                            notificationBackgroundColor={compareNotificationBackgroundColor}
                            notificationLabelColor={compareNotificationLabelColor}
                            showPulseEffect={products && products.length > 1}
                            onClick={handleCompare}
                        />
                    </div>
                </div>
            </div>
            <p className='compare-preview-label'>{products.length} de {maxItems} item(s)</p>
        </div>
    );
}

export default ComparePreview;